import { createSlice } from '@reduxjs/toolkit';

export const displayOptionsSettingsSlice = createSlice({
  name: 'displayOptionsSettings',
  initialState: {
    sections: []
  },
  reducers: {
    setDisplayOptionsSettingsSections: (state, action) => {
      state.sections = action.payload;
    }
  }
});

export const getDisplayOptionsSettingsSections = (state) => state.displayOptionsSettings.sections;

export const { setDisplayOptionsSettingsSections } = displayOptionsSettingsSlice.actions;

export default displayOptionsSettingsSlice.reducer;
